import { isAnyNativeEmbed, isEmbed } from '@databases/modes';
import { useEffect, useState } from 'react';

import { getExperimentValue } from '@canvas/client-feature-flags';
import { useIsDatabaseRovoAvailable } from '../rovo-enablement.ts';

export const useShouldShowDatabaseBlankObjectExperience = ({
  isEmptyDatabase,
  isDbAiFirstCreationEnabled,
  isDatabaseLoaded,
  isInAIFCStagingAreaView
}: {
  isEmptyDatabase: boolean;
  isDbAiFirstCreationEnabled: boolean;
  isDatabaseLoaded: boolean;
  isInAIFCStagingAreaView: boolean;
}) => {
  const isDatabaseRovoAvailable = useIsDatabaseRovoAvailable();

  const [shouldShowBlankObjectExperience, setShouldShowBlankObjectExperience] =
    useState<boolean>(false);

  useEffect(() => {
    const isEmbeddedDatabase = isEmbed() || isAnyNativeEmbed();

    if (
      !isDatabaseLoaded ||
      !isEmptyDatabase ||
      !isDbAiFirstCreationEnabled ||
      !isDatabaseRovoAvailable ||
      isInAIFCStagingAreaView ||
      isEmbeddedDatabase
    ) {
      setShouldShowBlankObjectExperience(false);
      return;
    }

    const isCwrBlankObjectExperimentEnabled = getExperimentValue(
      'cwrCanvasBlankObjectExperiment',
      'isEnabled',
      {
        fireExperimentExposure: true
      }
    );
    const cohort = isCwrBlankObjectExperimentEnabled
      ? getExperimentValue('cwrCanvasBlankObjectExperiment', 'cohort', {
          fireExperimentExposure: false
        })
      : 'control';
    const shouldShowExperience = cohort === 'variant1' || cohort === 'variant2';

    setShouldShowBlankObjectExperience(shouldShowExperience);
  }, [
    isDatabaseRovoAvailable,
    isEmptyDatabase,
    isDatabaseLoaded,
    isDbAiFirstCreationEnabled,
    isInAIFCStagingAreaView
  ]);

  return shouldShowBlankObjectExperience;
};
